module.exports = __webpack_public_path__ + "static/img/xajtdxfsdy.5351f0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/xajtdxfsdy.png
// module id = vSYa
// module chunks = 0